/**
 * Section names must match WebEngage / product taxonomy for Home Page Section Viewed.
 */
export const HOME_PAGE_SECTION_VIEWED = 'Home Page Section Viewed';

export const NEW_HOME_SECTION_VIEWED_NAME_CATEGORY_CARDS = 'Category Cards';
export const NEW_HOME_SECTION_VIEWED_NAME_BANNER_CAROUSEL = 'Banner Carousel';
export const NEW_HOME_SECTION_VIEWED_NAME_COLLECTIONS = 'Collections';
export const NEW_HOME_SECTION_VIEWED_NAME_REELS = 'Reels';
export const NEW_HOME_SECTION_VIEWED_NAME_PLP = 'PLP';

export function newHomeSectionViewedEventProperties(sectionName: string): Record<string, string> {
  return {
    'Section Name': sectionName,
  };
}

/**
 * Maps CMS `section.key` + rendered `view.type` to the analytics Section Name.
 * Returns null when this event should not fire (e.g. hero).
 */
export function resolveNewHomeSectionViewedSectionName(
  sectionKey: string,
  viewType: string,
): string | null {
  if (sectionKey === 'storeSelections') {
    return 'Store-visit Items';
  }
  if (sectionKey === 'categoryGrid' && viewType === 'grid') {
    return NEW_HOME_SECTION_VIEWED_NAME_CATEGORY_CARDS;
  }
  if (sectionKey === 'handpicked' && viewType === 'grid') {
    return NEW_HOME_SECTION_VIEWED_NAME_COLLECTIONS;
  }
  if (sectionKey === 'shopTheLook' && viewType === 'reels') {
    return NEW_HOME_SECTION_VIEWED_NAME_REELS;
  }
  if (sectionKey === 'recommended' && viewType === 'recommended') {
    return NEW_HOME_SECTION_VIEWED_NAME_PLP;
  }
  if (viewType === 'carousel' || viewType === 'parallaxCarousel') {
    return NEW_HOME_SECTION_VIEWED_NAME_BANNER_CAROUSEL;
  }
  return null;
}
